module.exports = __webpack_public_path__ + "media/src/images/buttons/hover_au-7de2094a088a3e6d975a4e2d53053214.svg";